import React from "react";
import ArrangeBoard from "@/components/nds/ArrangeBoard";
import { DeskCapTile } from "@/components/nds/CapabilityRoadmap";
import { useResidentActionCaps } from "@/lib/placement";

/** Resident Actions folder window: the six resident cards (only those this user may open), shared arrange order. */
export default function ResidentActionsContent() {
  const caps = useResidentActionCaps();
  const byId = Object.fromEntries(caps.map((c) => [c.id, c]));
  return (
    <div data-testid="resident-actions-content" className="h-full overflow-y-auto p-5 space-y-3">
      <p className="text-[12px] text-nex-muted">Everything you do for or about a resident. Each card opens its own window, the same as on the desk.</p>
      {caps.length ? (
        <ArrangeBoard board="resident_actions" label="cards" ids={caps.map((c) => c.id)} labels={Object.fromEntries(caps.map((c) => [c.id, c.label]))}
          gridClass="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" testid="resident-actions-board"
          renderTile={(id) => <DeskCapTile cap={byId[id]} />} />
      ) : <p data-testid="resident-actions-empty" className="text-sm text-nex-muted">You don't have access to any resident cards.</p>}
    </div>
  );
}
